var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
module.exports = x({ ["Drawer"]: () => (__WEBPACK_EXTERNAL_MODULE__static_theme_js_b1c2ef06__.Drawer), ["fetchCart"]: () => (__WEBPACK_EXTERNAL_MODULE__static_theme_js_b1c2ef06__.fetchCart), ["waitForEvent"]: () => (__WEBPACK_EXTERNAL_MODULE__static_theme_js_b1c2ef06__.waitForEvent) });